import React from 'react';
import './RadialChart.css';

const RadialChart = () => {
  const categories = [
    { name: 'Compute', color: '#e0f7fa', items: ['EC2', 'Lambda', 'Batch', 'Lightsail', 'EKS'] },
    { name: 'Containers', color: '#e3f2fd', items: ['ECS', 'ECR', 'Fargate', 'Copilot', 'App Runner'] },
    { name: 'Developer Tools', color: '#f3e5f5', items: ['CodeCommit', 'CodeBuild', 'CodeDeploy', 'Cloud9'] },
    { name: 'Networking', color: '#e8eaf6', items: ['VPC', 'Route53', 'CloudFront', 'Direct Connect'] },
    { name: 'Security', color: '#fce4ec', items: ['IAM', 'KMS', 'WAF', 'Shield', 'Inspector'] },
    { name: 'Storage', color: '#fff3e0', items: ['S3', 'EFS', 'FSx', 'Backup', 'Storage Gateway'] },
    { name: 'Database', color: '#f1f8e9', items: ['RDS', 'DynamoDB', 'ElastiCache', 'Redshift'] },
    { name: 'Analytics', color: '#e0f2f1', items: ['Athena', 'EMR', 'Glue', 'Quicksight', 'OpenSearch'] },
  ];

  const totalSlices = categories.length;
  const sliceAngle = 360 / totalSlices;
  const viewBoxSize = 800;
  const center = viewBoxSize / 2;
  const labelRadius = 360; // How far the curved text is from the center

  return (
    <div className="chart-container">
      <div className="canvas-wrapper">

        {/* SVG Layer for Curved Text Labels */}
        <svg className="curved-labels-svg" viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}>
          <defs>
            <path
              id="labelPath"
              d={`M ${center - labelRadius},${center} a ${labelRadius},${labelRadius} 0 1,1 ${labelRadius * 2},0 a ${labelRadius},${labelRadius} 0 1,1 -${labelRadius * 2},0`}
            />
          </defs>
          {categories.map((cat, i) => {
            // Offset the text so it centers within the slice's arc
            const startOffset = (i * (100 / totalSlices)) + (100 / (totalSlices * 2));
            return (
              <text key={i} className="curved-label-text">
                <textPath
                  href="#labelPath"
                  startOffset={`${startOffset}%`}
                  textAnchor="middle"
                >
                  {cat.name}
                </textPath>
              </text>
            );
          })}
        </svg>

        {/* The Colored Slices */}
        <div className="wheel-bg">
          {categories.map((cat, i) => (
            <div
              key={i}
              className="slice-part"
              style={{
                backgroundColor: cat.color,
                transform: `rotate(${i * sliceAngle}deg) skewY(${90 - sliceAngle}deg)`,
              }}
            />
          ))}
        </div>

        {/* Content Layer: Icons */}
        {categories.map((cat, i) => {
          const startAngle = i * sliceAngle;
          return (
            <div key={i} className="content-slice" style={{ transform: `rotate(${startAngle}deg)` }}>
              <div className="items-scatter-box">
                {cat.items.map((item, idx) => {
                  const dist = 120 + (idx * 35);
                  const shift = (idx % 2 === 0 ? 10 : 25);

                  return (
                    <div
                      key={idx}
                      className="node-item"
                      style={{ transform: `rotate(${shift}deg) translate(${dist}px) rotate(${-startAngle - shift}deg)` }}
                    >
                      <div className="node-icon"></div>
                      <p>{item}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}

        {/* Center Hub */}
        <div className="center-hub">
          <div className="hub-logo">MedRCM</div>
        </div>
      </div>
    </div>
  );
};

export default RadialChart;